// extracted by mini-css-extract-plugin
export default {"container":"ndvBlH","field":"cXMOgw","text":"wjsN8N mz-default-dark-font","ticketValidity":"lN6PWB"};